import { ReactElement } from 'react';
import { Space as AntSpace, SpaceProps } from 'antd';

export const Space = ({ style, ...restProps }: SpaceProps): ReactElement => (
  <AntSpace
    style={{
      width: '100%',
      ...style,
    }}
    {...restProps}
  />
);
